<div class="wrap">
  <div id="editor-el" tabindex="-1"></div>
</div>
